import { PrimeIcons } from 'primeng/api';

import { ValidationItem } from '../../lib.ts/validation';

export const ASSET_TYPES = {
    "Truck": {
        label: "Truck",
        icon: PrimeIcons.TRUCK,
    },
    "Estimator": {
        label: "Estimator",
        icon: PrimeIcons.CLIPBOARD,
    },
    "Overnight Storage": {
        label: "Overnight Storage",
        icon: PrimeIcons.WAREHOUSE,
    },
    "Delivery": {
        label: "Delivery",
        icon: PrimeIcons.BOX,
    },
} as const;

export const assetTypes = Object.values(ASSET_TYPES).map((t) => t.label);

export const assetTypesDropdown = Object.values(ASSET_TYPES).map((t) => ({ label: t.label, value: t.label }));

export interface CreateAssetFormValidation{
    name: ValidationItem;
}

export const assetValidation: CreateAssetFormValidation = {
    name: {
        message: 'Name is Required',
    },
};

export function formatCalendarAssetTitle(name: string, type?: string, description?: string): string {
          let calendarAssetType = '';
          let calendarAssetIcon = '';
    
          if (type) {
            calendarAssetType = ` (${type})`;
            
            if (type in ASSET_TYPES) {
              calendarAssetIcon = `<i class="${ASSET_TYPES[type].icon}"></i> `;
            } else {
              console.error(`${type} is an unexpected type of asset. Investigation needed!`)
            }
          }
    
          // We need to pass the style inline to be used in the full-calendar component
          const calendarAssetDescription = `${calendarAssetIcon}${description || ''}`;

    return `${name}${calendarAssetType}${calendarAssetDescription}`
}
